import React from 'react'
import PeopleCard from '../PeopleProfileCard';
import img1 from '../../../Images/Chiku.jpeg'

const createElements = () => {
  const elements = [];
  const PeopleImagesUrl = [img1];
  const PeopleName = ['Dr. Sunandini Swain'];
  const PeopleEmailId = ['sunandini.swain3@gmail.com'];
  const PeopleDescription = [
  `M.Tech. - Biotechnology, 2017
   B.Tech. - Biomedical Engineering, 2015
   PhD - IIT Patna, 2021 - 2026
   THESIS - MOLECULAR INSIGHTS INTO THE MECHANISTIC ACTIONS OF ALZHEIMER’S DISEASE THERAPEUTICS USING COMPUTATIONAL APPROACHES.`];

const Link = [
  " ",
  " ",
];

for (var i=0;i<PeopleName.length;i++){
    elements.push(<PeopleCard key = {i} peopleImagesUrl = {PeopleImagesUrl[i]} peopleName = {PeopleName[i]} peopleEmailId = {PeopleEmailId[i]} peopleDescription = {PeopleDescription[i]} link={Link[i]}/>)
}
return elements
}


const PhdScholar = () => {
return (
  <div className="album py-2">
    <div className="row">
    {createElements()}
  </div>
</div>
)
}

export default PhdScholar